var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrump',{attrs:{"breadcrump":_vm.breadcrump}}),_c('blog-article-template',{attrs:{"article":_vm.article}}),_c('social-share-buttons',{attrs:{"url":_vm.urlContent,"title":this.article.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }